import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import StackedPlot from '../../../graphics/StackedColumnPlot';
import { Title, Legend, ContLegend } from './styles';
import { Clientes } from './types';

const Stacked = () => {
  const [data, setData] = React.useState<any[]>([]);
  const dataState: Clientes[] = useSelector(
    (state: ApplicationState) => state.DashSla.data['clientes']
  );
  const concluidos = dataState?.map((item) => {
    return {
      client: item.razaoSocial,
      type: 'Concluído(s)',
      value: item.concluido,
      name: item?.razaoSocial?.toString()?.split(' ')[0],
    };
  });
  const pendentes = dataState?.map((item) => {
    return {
      client: item.razaoSocial,
      type: 'Pendente(s)',
      value: item.pendente,
      name: item?.razaoSocial?.toString()?.split(' ')[0],
    };
  });
  React.useEffect(() => {
    dataState?.length > 0 ? setData([...(concluidos ?? []), ...(pendentes ?? [])]) : setData([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataState]);

  return (
    <>
      <ContLegend>
        <Title>Atendimentos por clientes </Title>
        <Legend>
          <div className="concluido">
            {' '}
            <div /> Concluído
          </div>
          <div className="pendente">
            {' '}
            <div /> Pendente
          </div>
        </Legend>
      </ContLegend>
      <div style={{ width: '100%', padding: '10px' }}>
        <StackedPlot data={data} />
      </div>
    </>
  );
};

export default Stacked;
